import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Prescripteur } from 'src/app/shared/models/prescripteur';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { User } from 'src/app/shared/models/security/user';
import { saveAs } from 'file-saver';
import { PARAM_LABEL_BENEFICIAIRE } from 'src/app/core/services/constant/constants.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Subject, debounceTime, take } from 'rxjs';
import { LogService } from 'src/app/core/services/log/log.service';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';
import { PrescripteurModalAjoutFormComponent } from '../modal/prescripteur-modal-ajout-form/prescripteur-modal-ajout-form.component';
import { RegionCodeApiResponse } from 'src/app/shared/models/api-response/regionapi-response';
import { Region } from 'src/app/shared/models/region';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-prescripteur',
	templateUrl: './list-prescripteur.component.html',
	styleUrls: ['./list-prescripteur.component.scss']
})
export class ListPrescripteurComponent implements OnInit {
	prescripteurs: Prescripteur[];
	currentPage = 1;

	prescripteurCsvFile: File = null;
	sortType = 'nomStructure';
	sortOrder: SortOrder = 'asc';

	nextWeekNumber: number;
	handicaps: Record<string, string>;

	listExpertise: TypeHandicap[];
	listSelectedExpertise: TypeHandicap[] = [];

	searchedText: string;

	// nombre de page totale pour la pagination
	totalItems: number = 0;
	itemsPerPage = 10;

	user: User = null;
	isPlanif = false;
	labelPrescripteurCapitalized: string;
	labelPrescripteurPluralized: string;

	ajoutPrescripteurModalref: BsModalRef;

	isAddable = true;
	isImportable = false;
	isExportable = false;
	isAdmin: boolean;

	isMobile = false;
	screenWidth: number;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isAreaActive: boolean;

	isListingLoading: boolean = true;

	searchResults: RegionCodeApiResponse[];
	listRegion: Region[];

	private searchSubject = new Subject<string>();

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {
		// ajout de délai à la saisie de recherche pour ne pas bombarder le back de requête
		this.searchSubject
			.pipe(
				debounceTime(300) // Délai en millisecondes
			)
			.subscribe(() => {
				this.searchByInput();
			});
	}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.labelPrescripteurCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.labelPrescripteurPluralized =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_BENEFICIAIRE
			);

		this.user = this.facade.dataStorageService.getUser();
		this.isPlanif = this.facade.dataStorageService.isPlanificatrice();
		this.isAdmin = this.facade.dataStorageService.isAdmin();

		this.facade.regionService.getAllRegion().subscribe({
			next: (val) => {
				this.listRegion = val;
			},
			error: (err) => {
				this.logger.error(err);
			}
		});

		this.getPrescripteursMinimal();
	}

	getPrescripteursMinimal(): void {
		this.isListingLoading = true;
		if(this.isAdmin){
			this.facade.prescripteurService
				.getAllPrescripteurs()
				.subscribe({
				next: (prescripteurs: Prescripteur[]) => {
					this.prescripteurs = prescripteurs;
					this.currentPage = 1;
					this.isListingLoading = false;
					var codePostal;
					var pattern = new RegExp(/\b\d{5}\b/g);
					let prescripteurWithoutRegion : Prescripteur[] = [];

					for(let i = 0; i < this.prescripteurs.length; i++){
						if(this.prescripteurs[i].addressStructure != null && this.prescripteurs[i].addressStructure.label != null && 
							this.prescripteurs[i].region == null){
							codePostal = this.prescripteurs[i].addressStructure.label.match(pattern);
							if(codePostal != null){
								prescripteurWithoutRegion.push(this.prescripteurs[i]);
								console.log(i);
								console.log(codePostal[0]);
							}
						}
					}

					for(let i = 0; i < prescripteurWithoutRegion.length; i++){
						console.log(i);
						let codePostalNew = prescripteurWithoutRegion[i].addressStructure.label.match(pattern);
						setTimeout(()=>{
							this.getRegionFromAddress(codePostalNew[0], prescripteurWithoutRegion[i]);
						}, 3000*i);
					}
				},
				error: (err: ErrorResponse) => {
					this.logger.error(err + '');
				},
				complete: () => {
					this.isListingLoading = false;
				}
			});
		}else{
			this.facade.prescripteurService
				.getPrescripteurByRegion(this.facade.dataStorageService.getRegion()?.id)
				.subscribe({
					next: (prescripteurs: Prescripteur[]) => {
						this.prescripteurs = prescripteurs;
						this.currentPage = 1;
						this.isListingLoading = false;
					},
					error: (err: ErrorResponse) => {
						this.logger.error(err + '');
					},
					complete: () => {
						this.isListingLoading = false;
					}
				});
		}
	}

	getRegionFromAddress(codePostal: string, prescripteur: Prescripteur) {
		this.facade.nominatimService.regionCodeLookup(codePostal).subscribe({
			next: (result: any) => {
				this.searchResults = result.map(
					(result) =>
						new RegionCodeApiResponse(
							result.nom,
							result.code,
							result.codeDepartement,
							result.siren,
							result.codeEpci,
							result.codeRegion,
							result.codesPostaux,
							result.population
						)
				);
				console.log(this.searchResults);
				this.listRegion.forEach(reg => {
					if(reg.departements.find(dep => dep.code == this.searchResults[0].codeDepartement)){
						console.log(reg);
						prescripteur.region = reg;
						this.facade.prescripteurService.updatePrescripteur(prescripteur).subscribe({
							error: (err) => {
								this.logger.error(err);
							}
						})
					}
				})
			},
			error: (err) => {
				this.logger.error(err);
			}
		});
	}

	selectPrescripteur(prescripteur: Prescripteur): void {
		const link = ['/gestion/prescripteurs', prescripteur.id];
		this.router.navigate(link);
	}

	importPrescripteurs(event: any): void {
		this.isImportable = false;
		this.prescripteurCsvFile = event.target.files[0];
		this.facade.prescripteurService
			.importPrescripteurs(this.prescripteurCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.facade.toastService.createSuccessToast('Import effectué');
					this.getPrescripteursMinimal();
					this.isImportable = true;
				},
				error: (err: ErrorResponse) => {
					this.isImportable = true;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	exportPrescripteurs(): void {
		this.facade.exportService
			.exportPrescripteurs()
			.subscribe((blob) => saveAs(blob, 'prescripteur.csv'));
	}

	/**
	 * Fonction pour les paramètres de trie. Si le string choisi vaut le string courant l'on change l'ordre de trie (croissant/décroissant)
	 * sinon l'on chance la colonne de trie et l'on trie par ordre crosisant
	 * @param str colonne de trie
	 */
	sortChange(str: string): void {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}


	searchByInput() {
		this.currentPage = 1;
		this.getPrescripteursMinimal();
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		// const initialState = {
		// 	serviceCenter: this.user.employee.serviceCenter
		// };
		// if (this.user === null || this.user.employee.serviceCenter === null) {
		// 	this.facade.toastService.createErrorToast(
		// 		"Vous n'êtes pas rattaché à un centre."
		// 	);
		// } else {
			this.ajoutPrescripteurModalref = this.modalService.show(
				PrescripteurModalAjoutFormComponent,
				{
					class: 'modal-lg',
					//initialState,
					backdrop: 'static'
				}
			);
			this.ajoutPrescripteurModalref.content.updateListing
				.pipe(take(1))
				.subscribe((addedPrescripteur: Prescripteur) => {
					this.prescripteurs.push(addedPrescripteur);
				});
		//}
	}

	pageHasChanged(pageNumber: any) {
		this.currentPage = pageNumber;

		this.getPrescripteursMinimal();
	}

	updateSelectedExpertise(e: any, spe: TypeHandicap) {
		if (e.target.checked) {
			if (!this.listSelectedExpertise.some((e) => e.id === spe.id)) {
				this.listSelectedExpertise = [...this.listSelectedExpertise];
				this.listSelectedExpertise.push(spe);
			}
		} else {
			if (this.listSelectedExpertise.some((e) => e.id === spe.id)) {
				this.listSelectedExpertise = this.listSelectedExpertise.filter(
					(e) => e.id !== spe.id
				);
			}
		}
	}
}
